import '../../../styles/knowledge-concept/SubTopicCard.css';

import { Box, Card, CardContent, Tooltip, Typography } from '@mui/material';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import React, { useRef } from 'react';

import AddIcon from '@mui/icons-material/Add';
import Label from '../../atoms/Label';
import { addSIngleCardToMyPath } from '../../../services/MyPathService';
import clock from '../../../assets/ic_clock.svg';
import fire from '../../../assets/ic_fire.svg';
import { useSelector } from 'react-redux';

const { v4: uuid } = require('uuid');

const SubTopicCard = ({
	streak,
	lastStudied,
	progress,
	title,
	handleSubTopicClick,
	topicId,
	subtopicId,
	section,
	subtopicList,
	setCardSubtopics,
	setAlert,
	alertTimeoutRef,
	color,
}) => {
	const { userId } = useSelector((state) => state.userDetails);
	const addToMyPath = async () => {
		const newCard = {
			id: uuid(),
			topicId: topicId,
			subtopicId: subtopicId,
			subtopicName: title,
			saved: true,
			progress: progress,
		};
		const response = await addSIngleCardToMyPath(userId, section, newCard);
		if (response?.data) {
			setAlert({ status: true, severity: 'success', msg: 'Added to My Path Succesfully' });
			if (alertTimeoutRef.current) {
				clearTimeout(alertTimeoutRef.current);
			}
			alertTimeoutRef.current = setTimeout(() => {
				setAlert(false);
				alertTimeoutRef.current = null;
			}, 3000);
			setCardSubtopics((prev) => {
				prev[section] = [...prev?.[section], subtopicId];
				return { ...prev };
			});
		} else {
			setAlert({ status: true, severity: 'error', msg: 'Failed to add to My Path' });
			if (alertTimeoutRef.current) {
				clearTimeout(alertTimeoutRef.current);
			}
			alertTimeoutRef.current = setTimeout(() => {
				setAlert(false);
				alertTimeoutRef.current = null;
			}, 3000);
		}
	};
	return (
		<Tooltip placement="top-start" title={title} followCursor>
			<Card
				sx={{
					display: 'flex',
					minWidth: '15.5rem',
					maxWidth: '15.5rem',
					padding: '0.35rem',
					minHeight: '6.45rem',
					maxHeight: '6.45rem',
					boxShadow: '4px 7px 4px 0px rgba(0, 0, 0, 0.25)',
					border: '1px solid rgb(129, 129, 129)',
					// backgroundColor: '#000080',
					cursor: 'pointer',
					borderRadius: '10px',
				}}
			>
				<CardContent
					sx={{
						flex: '1 0 auto',
						width: '57%',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'flex-start',
						paddingX: '0',
						paddingY: '0.5rem',
						flexDirection: 'column',
						overflow: 'hidden', // Required
						height: '100%', // Ensures line clamping respects height
					}}
					onClick={handleSubTopicClick}
				>
					{/* <Typography
					variant="body"
					gutterBottom
					component={'p'}
					sx={{
						width: '100%',
						display: 'block',
						fontFamily: 'Helvetica',
						fontSize: '1rem',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'wrap',
						textAlign: 'start',
						color: 'white',
						height: '100%',
					}}
				>
					{title || 'Sub Topic Name'}
				</Typography> */}

					<p
						style={{
							display: '-webkit-box',
							WebkitLineClamp: 2,
							WebkitBoxOrient: 'vertical',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							fontFamily: 'Helvetica',
							fontSize: '1rem',
							fontWeight: 'bold',
							// color: 'white',
							margin: 0,
							textAlign: 'start',
							width: '100%',
							// height: '100%', // Ensures line clamping respects height
							whiteSpace: 'break-spaces',
						}}
					>
						{title || 'Sub Topic Name'}
					</p>
					<Box>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '0.5rem',
								flexDirection: 'row',
							}}
						>
							<img src={fire} alt="fire" />
							<p
								style={{
									display: '-webkit-box',
									WebkitLineClamp: 3,
									WebkitBoxOrient: 'vertical',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									fontFamily: 'Helvetica',
									fontSize: '10px',
									// color: 'white',
									maxLines: 1,
									margin: 0,
									textAlign: 'start',
									width: '100%',
									height: '100%', // Ensures line clamping respects height
									whiteSpace: 'break-spaces',
								}}
							>
								{'Streak: ' + streak + ' Days'}
							</p>
						</div>
					</Box>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '0.5rem',
							flexDirection: 'row',
						}}
					>
						<img src={clock} alt="clock" />
						<p
							style={{
								display: '-webkit-box',
								WebkitLineClamp: 3,
								WebkitBoxOrient: 'vertical',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								fontFamily: 'Helvetica',
								fontSize: '10px',
								// color: 'white',
								maxLines: 1,
								margin: 0,
								textAlign: 'start',
								width: '100%',
								height: '100%', // Ensures line clamping respects height
								whiteSpace: 'break-spaces',
							}}
						>
							{'Last Studied: ' + (lastStudied === null ? 'N/A' : lastStudied)}
						</p>
					</div>
				</CardContent>
				<Box
					sx={{
						width: '40%',
						height: 'auto',
						alignItems: 'center',
						display: 'flex',
						justifyContent: 'center',
					}}
					onClick={handleSubTopicClick}
				>
					<CircularProgressbar
						value={progress}
						text={`${progress}%`}
						strokeWidth={15}
						styles={buildStyles({
							// pathColor:progress === 100 ? 'green' : progress > 60 ? '#F98D30' : 'red',
							pathColor: color,
							textColor: 'black',
							// progress === 100
							// 	? 'green'
							// 	: progress > 60
							// 	? '#F98D30'
							// 	: progress !== 0
							// 	? 'red'
							// 	: 'black',
						})}
					/>
				</Box>
				{!subtopicList?.includes(subtopicId) && (
					<Box
						sx={{
							height: 'auto',
							width: 'fit-content',
							justifyContent: 'start',
							alignItems: 'start',
						}}
					>
						<AddIcon sx={{ color: '#1F21E6' }} onClick={addToMyPath} />
					</Box>
				)}
			</Card>
		</Tooltip>
	);
};

export default SubTopicCard;
